import classnames from 'classnames'
import { Toggle } from '@/components/atoms'

type SettingsToggleCardProps = {
    checked: boolean
    disabled?: boolean
    onChange?: (checked: boolean) => void
    title: string
    description?: string
    className?: string
}

export const SettingsToggleCard: React.FC<SettingsToggleCardProps> = (
    props
) => {
    const { title, description, checked, disabled, onChange, className } = props

    const baseClassName =
        'flex items-start justify-between rounded-lg px-3 py-2 shadow-xs outline-0'

    const settingsToggleCardClassname = classnames(baseClassName, className, {
        'border border-neutral-300 cursor-pointer bg-white hover:bg-blue-50 hover:border-blue-200 [&:not(:disabled)]:active:bg-blue-100 [&:not(:disabled)]:active:border-blue-200':
            !disabled,
        'bg-neutral-50': disabled,
    })

    return (
        <div
            tabIndex={0}
            className={settingsToggleCardClassname}
            data-testid="settings-toggle-card"
            onClick={() => {
                if (disabled) return

                onChange?.(!checked)
            }}
        >
            <div className="grid gap-1">
                <div
                    className={`text-label-small ${!disabled ? 'text-regular' : 'text-neutral-400'}`}
                    data-testid="toggle-title"
                >
                    {title}
                </div>
                {description && (
                    <div
                        className={`text-xs ${!disabled ? 'text-subtle' : 'text-neutral-400'}`}
                        data-testid="toggle-description"
                    >
                        {description}
                    </div>
                )}
            </div>
            <div className="shrink-0">
                <Toggle checked={checked} disabled={disabled} />
            </div>
        </div>
    )
}
